exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "nav.horizontal-nav{width:100%}.horizontal-nav .nav-body,nav.horizontal-nav .inner{height:100%}.horizontal-nav .nav-body .item{height:100%;display:inline}.horizontal-nav .nav-body .item.forceVerticalAlign *{vertical-align:middle}", ""]);

// exports
